var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 2000 100",
    width: 2000,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2000,
    height: 100,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 78L33.3 73.7C66.7 69.3 133.3 60.7 200 56.2C266.7 51.7 333.3 51.3 400 55.2C466.7 59 533.3 67 600 71.3C666.7 75.7 733.3 76.3 800 74.8C866.7 73.3 933.3 69.7 1000 64.8C1066.7 60 1133.3 54 1200 55.2C1266.7 56.3 1333.3 64.7 1400 69C1466.7 73.3 1533.3 73.7 1600 74.5C1666.7 75.3 1733.3 76.7 1800 71.3C1866.7 66 1933.3 54 1966.7 48L2000 42L2000 101L1966.7 101C1933.3 101 1866.7 101 1800 101C1733.3 101 1666.7 101 1600 101C1533.3 101 1466.7 101 1400 101C1333.3 101 1266.7 101 1200 101C1133.3 101 1066.7 101 1000 101C933.3 101 866.7 101 800 101C733.3 101 666.7 101 600 101C533.3 101 466.7 101 400 101C333.3 101 266.7 101 200 101C133.3 101 66.7 101 33.3 101L0 101Z",
    fill: "#7f5af0",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.fb2de7f2dd713c9c1a413be32473b0a5.svg";
export { ForwardRef as ReactComponent };